// extracted by mini-css-extract-plugin
module.exports = {"cart":"cart_cart__12Z7E","currentSection":"cart_currentSection__27tHJ","paper":"cart_paper__b7CmQ"};